import Hero from '@/components/hero';
import Feature from '@/components/feature';
import Line from '@/components/line';
import Process from '@/components/process';
import Example from '@/components/example';
import Work from '@/components/work';
import Price from '@/components/priceV1';
import Awards from '@/components/awards';
import Logos from '@/components/logos';
import NetworkVisualization from '@/components/brand';

export default function Home() {
  return (
    <>
      <Hero />
      <Logos />
      <Line variant="small" />
      <NetworkVisualization />
      <Feature />
      <Line variant="medium" />
      <Process />
      <Example />
      <Line variant="medium" />
      <Work />
      <Price />
      <Awards />
    </>
  );
}
